function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { node, string, bool } from "prop-types";
import classNamesMaker from "classnames";
import { CloseButton } from "#library/components/Modal/CloseButton/CloseButton";
import { ModalHeader as Header } from "#library/components/Modal/Header/ModalHeader";
import { ModalFooter as Footer } from "#library/components/Modal/Footer/ModalFooter";
import { ModalBody as Body } from "#library/components/Modal/Body/ModalBody";
import { useModal } from "#library/components/Modal/ModalManagement/ModalContext";
import { spreadChildren } from "#library/components/Modal/utils";
import styles from "#library/components/Modal/modal.module.css";
export var ModalLayout = function ModalLayout(_ref) {
  var children = _ref.children,
    wrapperClassName = _ref.wrapperClassName;
  var _useModal = useModal(),
    onClose = _useModal.onClose,
    onOutsideClick = _useModal.onOutsideClick,
    onSubmit = _useModal.onSubmit,
    isForm = _useModal.isForm,
    type = _useModal.type,
    wrapperProps = _useModal.wrapperProps,
    isFooterSticky = _useModal.isFooterSticky,
    _useModal$isContentCe = _useModal.isContentCentered,
    isContentCentered = _useModal$isContentCe === void 0 ? false : _useModal$isContentCe;
  var _spreadChildren = spreadChildren(children),
    headerChildren = _spreadChildren.headerChildren,
    footerChildren = _spreadChildren.footerChildren,
    bodyChildren = _spreadChildren.bodyChildren,
    headerHasIcon = _spreadChildren.headerHasIcon;
  if (!headerChildren || headerChildren.length === 0) {
    throw new Error("[Modal] Please use <Modal.Header /> and <Modal.Title />");
  }
  var stylesWrapper = classNamesMaker(styles["jds-Modal__wrapper"], type && styles["jds-Modal__wrapper--".concat(type)], isFooterSticky && styles["jds-Modal__wrapper--stickyFooter"], isContentCentered && styles["jds-Modal__wrapper--isCentered"], wrapperClassName);
  var enhancedWrapperProps = _objectSpread(_objectSpread({}, isForm && {
    onSubmit: onSubmit,
    role: "form"
  }), wrapperProps);
  var TagWrapper = isForm ? "form" : "div";
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    React.createElement("div", {
      className: styles["jds-Modal"],
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "dialogTitle",
      "aria-describedby": "dialogDesc"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["jds-Modal__background"],
      onClick: function onClick() {
        onClose();
        onOutsideClick();
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement(TagWrapper, _extends({
      className: stylesWrapper
    }, enhancedWrapperProps), /*#__PURE__*/React.createElement(CloseButton, null), /*#__PURE__*/React.createElement(Header, {
      hasIcon: headerHasIcon
    }, headerChildren), /*#__PURE__*/React.createElement(Body, null, bodyChildren), /*#__PURE__*/React.createElement(Footer, null, footerChildren)))
  );
};
ModalLayout.propTypes = {
  children: node,
  isContentCentered: bool,
  wrapperClassName: string
};